import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from 'LiveBoard/components/shared/Avatar'
import { ItemModalActionButtons } from 'LiveBoard/components/shared/ItemModalActionButtons'
import { DummyAnchorTag } from 'LiveBoard/components/shared/DummyAnchorTag'

import './style.css.scss'

const NavigationPanel = React.memo((props) => {
  const NAVIGATION_ITEMS = {
    nextItem: {
      onClick: props.onNextItem,
      className: 'icon-chevron-right',
      itemUrl: props.nextItemUrl,
      arrowColor: props.themeColorHex
    },
    prevItem: {
      onClick: props.onPrevItem,
      className: 'icon-chevron-left',
      itemUrl: props.prevItemUrl,
      arrowColor: props.themeColorHex
    }
  }

  const NavigationArrow = (props) => {
    const { navigationItem } = props
    return (
      <DummyAnchorTag url={navigationItem.itemUrl}>
        <span onClick={navigationItem.onClick}>
          <div className={navigationItem.className} style={{color: navigationItem.arrowColor}} />
        </span>
      </DummyAnchorTag>
    )
  }

  return (
    <div className='navigation-panel'>
      { props.hasNavigation &&
        <NavigationArrow navigationItem={NAVIGATION_ITEMS.prevItem} /> }
      { props.showSeller ?
        <Avatar url={props.seller.photo} onClick={props.onSellerClick} /> :
        <>
          { props.showActionButtons &&
            <ItemModalActionButtons data={props.actionButtons}/>
          }
        </>
      }
      { props.hasNavigation &&
        <NavigationArrow navigationItem={NAVIGATION_ITEMS.nextItem} /> }
    </div>
  )
})

NavigationPanel.propTypes = {
  seller: PropTypes.object.isRequired,
  showSeller: PropTypes.bool.isRequired,
  showActionButtons: PropTypes.bool.isRequired,
  onNextItem: PropTypes.func,
  onPrevItem: PropTypes.func,
  hasNavigation: PropTypes.bool.isRequired,
  onSellerClick: PropTypes.func.isRequired,
  actionButtons: PropTypes.object.isRequired,
  nextItemUrl: PropTypes.string.isRequired,
  prevItemUrl: PropTypes.string.isRequired
}

export default NavigationPanel
